const POSTCODE_LOOKUP_ENDPOINT = "https://api.postcodes.io/postcodes";

function postcodeError(code, message) {
  const error = new Error(message);
  error.code = code;
  return error;
}

export function normalizePostcode(value) {
  return String(value || "").trim().toUpperCase().replace(/\s+/g, " ");
}

export async function lookupPostcode(value, fetchImpl = fetch) {
  const postcode = normalizePostcode(value);
  if (postcode.length < 5 || postcode.length > 12) {
    throw postcodeError("invalid-postcode", "Enter a complete UK postcode.");
  }
  if (typeof fetchImpl !== "function") {
    throw postcodeError("lookup-unavailable", "Postcode lookup is temporarily unavailable.");
  }

  let response;
  try {
    response = await fetchImpl(
      `${POSTCODE_LOOKUP_ENDPOINT}/${encodeURIComponent(postcode)}`,
      { headers: { Accept: "application/json" } }
    );
  } catch (error) {
    throw postcodeError("lookup-unavailable", "Postcode lookup is temporarily unavailable.");
  }

  if (response.status === 404) {
    throw postcodeError("postcode-not-found", "We could not find that postcode. Check it or place the pin manually.");
  }
  if (!response.ok) {
    throw postcodeError("lookup-unavailable", "Postcode lookup is temporarily unavailable.");
  }

  const body = await response.json();
  const latitude = body?.result?.latitude;
  const longitude = body?.result?.longitude;
  if (
    typeof latitude !== "number"
    || typeof longitude !== "number"
    || !Number.isFinite(latitude)
    || !Number.isFinite(longitude)
  ) {
    throw postcodeError("coordinates-unavailable", "Coordinates are unavailable for that postcode. Place the pin manually.");
  }

  return {
    postcode: normalizePostcode(body.result.postcode || postcode),
    lat: latitude,
    lng: longitude,
  };
}
